/**
 * PIPCARE-1358: "My views" in the sidebar. Saved per browser in localStorage only,
 * so they never leave this computer (shared, server-side views are PIPCARE-1360).
 */
export interface SavedPatientView {
  id: string;
  title: string;
  /** The Patients query string, e.g. "?filter=hospital:eq:DHEC&sort=surgery_date". */
  query: string;
}

export const SAVED_VIEWS_KEY = "capable.patients.savedViews";
export const SAVED_VIEWS_EVENT = "capable:saved-patient-views";
export const MAX_TITLE_LENGTH = 40;

export const loadSavedViews = (): SavedPatientView[] => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(SAVED_VIEWS_KEY) || "[]");
    return Array.isArray(parsed)
      ? parsed.filter((view) => view && typeof view.title === "string" && typeof view.query === "string")
      : [];
  } catch {
    return [];
  }
};

const store = (views: SavedPatientView[]): boolean => {
  try {
    window.localStorage.setItem(SAVED_VIEWS_KEY, JSON.stringify(views));
    window.dispatchEvent(new Event(SAVED_VIEWS_EVENT));
    return true;
  } catch {
    return false;
  }
};

/** Saves (or replaces, by title) a view. Returns false if the browser blocks storage. */
export const savePatientView = (title: string, query: string): boolean => {
  const cleanTitle = title.trim().slice(0, MAX_TITLE_LENGTH);
  if (!cleanTitle) return false;

  const views = loadSavedViews().filter((view) => view.title.toLowerCase() !== cleanTitle.toLowerCase());
  views.push({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, title: cleanTitle, query });
  return store(views);
};

export const deletePatientView = (id: string): boolean =>
  store(loadSavedViews().filter((view) => view.id !== id));
